import React from "react";
import "./BoysBranch.css";

function BoysBranch() {
  return (
    <div className="boys-branch-containers">
      {/* Header Section */}
      <header className="branch-header">
        <h1>Boys Branch</h1>
        <p>
          Welcome to the Boys Branch campus. We are committed to providing
          quality education and a supportive environment for our students.
        </p>
      </header>

      {/* Campus Info Section */}
      <section className="branch-info">
        <h2>About Our Branch</h2>
        <p>
          Our Boys Branch is equipped with modern classrooms, science labs,
          computer labs, sports facilities, and a dedicated faculty to ensure
          the best learning experience. We focus on academics, character
          building, and extracurricular activities to help students grow in all
          aspects of life.
        </p>
      </section>

      {/* Facilities Section */}
      <section className="branch-facilities">
        <h2>Facilities</h2>
        <ul>
          <li>Spacious Classrooms</li>
          <li>Science & Computer Labs</li>
          <li>Library</li>
          <li>Sports Ground</li>
          <li>Transport Facility</li>
        </ul>
      </section>

      {/* Contact Details */}
      <section className="branch-contact">
        <h2>Contact Information</h2>
        <p>
          <strong>Address:</strong> 5FC7+3X9, Road, Naveed Town, Multan, Pakistan
        </p>
        <p>
          <strong>Phone:</strong> +92 304 7630462
        </p>
        <p>
          <strong>Email:</strong> academicgroupofschools@gmail.com
        </p>
      </section>

      {/* Google Map Embed */}
      <section className="branch-map">
        <h2>Find Us on Map</h2>
        <div className="map-container">
          <iframe
            title="Boys Branch Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13622.229915418517!2d71.4653778!3d30.1701592!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x393b3229a52ab4ad%3A0x123456789abcdef!2s5FC7%2B3X9%2C%20Road%2C%20Naveed%20Town%2C%20Multan%2C%20Pakistan!5e0!3m2!1sen!2s!4v1694936502045!5m2!1sen!2s"
            width="100%"
            height="350"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
        <a
          href="https://www.google.com/maps?q=5FC7+3X9,+Road,+Naveed+Town,+Multan,+Pakistan"
          target="_blank"
          rel="noopener noreferrer"
          className="directions-btn"
        >
          📍 Get Directions
        </a>
      </section>
    </div>
  );
}

export default BoysBranch;
